namespace advisorop.components.meetinghub {
    export class CuMeetingController {
        onScheduleMeetingLater: any;
        onCreateMeeting: any;
        onUpdateMeeting: any;
        onCancel: any;
        meeting: domains.IMeeting;
        meetingDate: Date;
        isAdvisor: boolean;
        isInvestorScheduler: boolean;
        setMeetingTime: boolean = false;
        availableMeetingTimes: Array<domains.IMeetingAvailabilityDuration>;
        selAdvisor: domains.IAdvisor;
        advisors: Array<domains.IAdvisor>;
        households: Array<domains.IHousehold>;
        householdInvestors: Array<domains.IInvestor> = [];
        meetingParticipants: Array<domains.IMeetingParticipant> = [];
        meetingLengthString: string = "30";
        meetingLength: number = 30;
        currentValue: Date = new Date();
        meetingTimes: Array<domains.IMeetingAvailabilityTime>;
        selMeetingTime: domains.IMeetingAvailabilityTime;

        householdAutoCompleteOptions: DevExpress.ui.dxAutocompleteOptions;
        householdAutoComplete: DevExpress.ui.dxAutocomplete;
        calendarOption: DevExpress.ui.dxCalendarOptions;
        calendar: DevExpress.ui.dxCalendar;
        //o: DevExpress.ui.dxDataGridOptions
        constructor(private meetingHubService: services.MeetingHubService, private servicerService: services.ServicerService, private generalService: services.GeneralService) {
            this.calendarOption = {
                bindingOptions: {
                    value: "vm.currentValue"
                },
                disabledDates: (e) => {
                    return this.onDisableDate(e);
                },
                onInitialized: (e) => {
                    this.calendar = e.component;
                },
                onValueChanged: (e) => {
                    this.onCalendarValueChanged(e);
                }
            }

            this.householdAutoCompleteOptions = {
                bindingOptions: {
                    dataSource: "vm.households"
                },
                searchExpr: "name",
                placeholder: 'Type household name...',
                valueExpr: "name",
                onSelectionChanged: (e) => {
                    this.onHouseholdSelected(e);
                },
                onInitialized: (e) => {
                    this.householdAutoComplete = e.component;
                }
            }
        }

        equalDates(date1: Date, date2: Date): boolean {
            var match = date1.getFullYear() == date2.getFullYear();
            match = match && date1.getMonth() == date2.getMonth();
            match = match && date1.getDate() == date2.getDate();
            return match
        }

        onDisableDate(e): boolean {
            var today = new Date();
            var disable = true;
            var dateValue: Date = e.date;
            if (dateValue < today)
                return disable;

            if (this.availableMeetingTimes != undefined && this.availableMeetingTimes.length > 0) {
                //var daysArray = this.availableMeetingTimes.filter(m => m.duration == this.meetingLength);
                //var days = daysArray[0].days;
                //var availableDays = days.some((d: domains.IMeetingAvailabilityDay) => {
                //    //var indexOfT = (d.date as unknown as string).indexOf('T');
                //    //var dateString = (d.date as unknown as string).slice(0, indexOfT);
                //    //var year = (d.date as Date).getFullYear();
                //    //var month = (d.date as Date).getMonth();
                //    //var day = (d.date as Date).getDate();
                //    var date = new Date(d.date);
                //    date = new Date(date.setTime(date.getTime() + dateValue.getTimezoneOffset() * 60 * 1000));
                //    var match = this.equalDates(date, dateValue);
                //    return match;
                //});
                disable = !this.availableMeetingTimes.filter(m => m.duration == this.meetingLength)[0].days.some(d => {
                    var date = new Date(d.date);
                    //date = new Date(date.setTime(date.getTime() + dateValue.getTimezoneOffset() * 60 * 1000));
                    var match = this.equalDates(date, dateValue);
                    return match;
                });
            }
            return disable;
        }

        onCalendarValueChanged(e): void {
            this.setMeetingTimes();
        }

        onAdvisorSelected(): void {
            this.households = [];
            this.householdInvestors = [];
            this.meetingHubService.getHouseholdsByAdvisor(this.selAdvisor.id).then(response => {
                this.households = response.data;
            }, err => this.generalService.showError(err));
            this.meeting.advisor = this.selAdvisor;
        };

        onHouseholdSelected(e): void {
            this.meeting.participants = [];
            var hhIndex = this.households.indexOf(e.selectedItem)
            if (hhIndex != -1) {
                this.householdInvestors = this.households[hhIndex].investors.concat();
                this.meeting.household = this.households[hhIndex];
            }
        };

        onStartDateChanged(e: any) {
            var date = e.value;
            this.meeting.endDate = new Date(date.getTime() + 60 * 1000 * 30);
            console.log(e);
        };

        onDurationChange(): void {
            this.meetingLength = parseInt(this.meetingLengthString);
            this.setMeetingTimes();
        }

        setMeetingTimes(): void {
            var meetingTimesDurations = this.availableMeetingTimes.filter(t => t.duration == this.meetingLength)[0];
            this.meetingTimes = meetingTimesDurations.days.filter(d => {
                var date = new Date(d.date);
                var match = this.equalDates(date, this.currentValue);
                return match;
            })[0].times;
            //console.log("MEETING TIMES:", this.meetingTimes);
        }

        onMeetingTimeChanged(): void {
            this.meeting.startDate = new Date(this.selMeetingTime.startTime);
            this.meeting.endDate = new Date(this.selMeetingTime.endTime);
        }

        timeLabelDate(time: domains.IMeetingAvailabilityTime): string {
            var startDate = new Date(time.startTime);
            var endDate = new Date(time.endTime);
            var label = startDate.toLocaleTimeString('en-US') + " - " + endDate.toLocaleTimeString('en-US');
            return label;
        }
        investorsSelected(investors: Array<domains.IInvestor>) {
            this.meeting.participants = [];
            investors.forEach(i => {
                var participant = { investorId: i.id, name: i.fullName };
                this.meeting.participants.push(participant);
            })
            console.log(this.meeting.participants);
        }

        createMeeting(scheduleLater: boolean): void {
            if (scheduleLater) {
                this.onScheduleMeetingLater();
            }
            else {
                this.onCreateMeeting();
            }
        };

        scheduleMeeting(): void {
            this.setMeetingTime = true;
        }

        okToSchedule(): boolean {
            return (
                this.meeting?.household?.id &&
                this.meeting?.participants?.length > 0
            )
        }
        okToSave(): boolean {
            return (
                this.okToSchedule() &&
                this.meeting?.startDate != undefined &&
                this.meeting?.endDate != undefined
                );
        }

        updateMeeting(): void {
            this.onUpdateMeeting();
        }

        cancel(): void {
            this.onCancel();
        };

        isNewMeeting(): boolean {
            var isNewMeeting = this.isInvestorScheduler != true || this.meeting?.status == domains.MeetingStatus.RESERVED;
            return isNewMeeting;
        }

        getAdvisor(): void {
            this.advisors = [];
            this.servicerService.getAdvisors(1).then(response => {
                this.advisors = response.data;
            }, err => this.generalService.showError(err));
        };

        getHouseholds(): void {
            this.households = [];
            this.meetingHubService.getHouseholds().then(result => {
                this.households = result.data.concat();
                if (this.meeting?.household != undefined && this.householdInvestors.length == 0) {
                    this.householdInvestors = this.households.filter(hh => hh.id == this.meeting.household.id)[0].investors.concat();
                }
            })
        }

        $onInit(): void {
            if (this.isInvestorScheduler == undefined || !this.isInvestorScheduler) {
                if (this.isAdvisor != undefined && !this.isAdvisor)
                    this.getAdvisor();
                else
                    this.getHouseholds();
            }
        }

        $onChanges(evt) {
            console.log(evt);
            if (this.calendar != undefined) {
                this.calendar.repaint();
            }
            if (this.meetingDate != undefined) {
                this.currentValue = new Date(this.meetingDate);
            }
            if (this.availableMeetingTimes != undefined) {
                this.setMeetingTimes();
            }
            if (this.householdAutoComplete != undefined) {
                if (this.meeting.household != undefined) {
                    var householdName = this.meeting.household.name;
                    this.householdAutoComplete.option("value", householdName);
                    if (this.households.length > 0) {
                        this.householdInvestors = this.households.filter(hh => hh.id == this.meeting.household.id)[0].investors.concat();
                    }
                    this.meetingParticipants = this.meeting.participants.concat();
                    var length = (new Date(this.meeting.endDate)).getTime() - (new Date(this.meeting.startDate)).getTime();
                    var mins = Math.round(length / 60000);
                    this.meetingLength = mins;
                    if (this.availableMeetingTimes != undefined) {
                        this.setMeetingTimes();
                        var timeSlot = this.meetingTimes.filter(t => {
                            var tsDate = new Date(t.startTime);
                            var mtDate = new Date(this.meeting.startDate);
                            var match = tsDate.getHours() == mtDate.getHours();
                            match = match && (tsDate.getMinutes() == mtDate.getMinutes());
                            return match;
                        });
                        if (timeSlot.length > 0) {
                            this.selMeetingTime = timeSlot[0];
                        }
                    }
                }
            }
            if (this.isInvestorScheduler != undefined) {
                this.setMeetingTime = this.isInvestorScheduler;
            }
        }
    }

    class CuMeeting implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                meeting: "<",
                meetingDate: "<",
                isAdvisor: "<",
                isInvestorScheduler: "<",
                availableMeetingTimes: "<",
                onScheduleMeetingLater: "&",
                onCreateMeeting: "&",
                onUpdateMeeting: "&",
                onCancel: "&"
            };
            this.controller = [`meetingHubService`, `servicerService`, `generalService`, CuMeetingController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/meeting-hub-module/components/cu-meeting.html`;
        }
    }
    angular.module(Constants.APP).component(`cuMeeting`, new CuMeeting());
}